import { useLingui } from "@lingui/react/macro";
import { Text } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DocHeading } from "@/components/docs/DocHeading.tsx";
import { DocsContent } from "@/components/docs/DocsContent";

export const Route = createFileRoute("/docs/getting-started/projects")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useLingui();

  return (
    <DocsContent>
      <DocHeading order={1} size="h2">{t`Projects`}</DocHeading>
      <Text>
        {t`Projects in REALity are used to organize and manage property-related information, datasets,
        and user permissions within the platform. We're currently working on the documentation for this page.
        Contact our support team for assistance in the meantime. You find a link to the support form in the menu in the right top corner.`}
      </Text>
    </DocsContent>
  );
}
